import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Select from 'react-select';
import API from '../../api/axios';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useQuery } from 'react-query';

const SelectState = React.memo(
  ({
    isMulti = false,
    onSelect,
    placeholder = 'انتخاب استان',
    state,
    isDisabled = false,
    width = '100%',
    height = 56,
    isClearable = true,
    error = false,
    helperText = '',
    ...rest
  }) => {
    const [states, setStates] = useState(null);

    const loadStates = async () => {
      // let filter = Array();
      // mostUse !== undefined && filter.push(`mostUse=${mostUse}`);
      // isDest !== undefined && filter.push(`isDest=${isDest}`);
      // !!state && filter.push(`state=${state}`);
      // let query = filter.join("&");
      // const url = `/api/v1/admin/state/list`;
      try {
        // const { data } = await API.get(url);
        const res = await fetch('/states.json');
        const data = await res.json();
        return data;
        setStates(data);
      } catch (err) {
        console.error(err);
      }
    };
    const handleSelectState = (state) => {
      onSelect(state);
    };
    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        height,
        width,
      }),
      menu: (provided, state) => ({
        ...provided,
        zIndex: 10,
      }),
    };

    // useEffect(() => {
    //   loadStates();
    // }, []);

    const { data, isLoading } = useQuery('loadStateAdminPanel', loadStates, {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24 * 30,
      cacheTime: Infinity,
    });

    return (
      <>
        {!isLoading ? (
          <>
            <Select
              options={data.map((state) => ({
                label: state.title,
                value: state._id,
              }))}
              isMulti={isMulti}
              isSearchable={true}
              placeholder={placeholder}
              value={state}
              onChange={(option) => handleSelectState(option)}
              noOptionsMessage={() => 'استانی یافت نشد'}
              isDisabled={isDisabled}
              styles={customStyles}
              isClearable={isClearable}
              {...rest}
            />
            <FormHelperText error={error}>{helperText}</FormHelperText>
          </>
        ) : (
          <Skeleton
            height={height}
            animation="wave"
            variant="rect"
            width={width}
          />
        )}
      </>
    );
  }
);

export default SelectState;
